/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, map, catchError, takeUntil } from 'rxjs/operators';
import { cashboxesClient } from '../../../api/cashBoxes/cashboxesClient';
import { from, of } from 'rxjs';
import { parseError } from '../../../../utils/utils';
import { i18n } from '../../../translation/i18n';
import { AxiosError } from 'axios';
import {
    CashBoxLastDocumentTabAction,
    CashBoxLastDocumentTabActionType,
    fetchLastDocumentErrorAction,
    fetchLastDocumentSuccessAction,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxLastDocumentActions';

export const fetchCashBoxLastDocumentEpic: Epic<CashBoxLastDocumentTabAction> = (action$) => {
    return action$.pipe(
        ofType(CashBoxLastDocumentTabActionType.FETCH_LAST_DOCUMENT),
        switchMap((action) => {
            const { taxNumber } = action.payload;

            return from(cashboxesClient.getCashBoxLastDocument(taxNumber)).pipe(
                map((resp) => {
                    return fetchLastDocumentSuccessAction(resp);
                }),
                catchError((err: AxiosError) =>
                    of(
                        fetchLastDocumentErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.failedToGetDocument')),
                        ),
                    ),
                ),
                takeUntil(action$.pipe(ofType(CashBoxLastDocumentTabActionType.EXIT_LAST_DOCUMENT_TAB))),
            );
        }),
    );
};
